export default {
  state: {
    startTest: false,
    playingGame: false,
    gameLoading: false,
    answerValues: 0,
    total: 0,
    questionArray: [],
    games: {
      jump: {
        complete: false
      },
      tower: {
        complete: false
      },
      puzzle: {
        complete: false
      }
    }
  },
  mutations: {
    CLEAR_DATA (state, payload) {
      if (payload) {
        state[payload] = null
      } else {
        state.startTest = false
        state.answerValues = 0
        state.total = 0
        state.games = {
          jump: {
            complete: false
          },
          tower: {
            complete: false
          },
          puzzle: {
            complete: false
          }
        }
        state.one = null
        state.two = null
        state.three = null
        state.four = null
        state.five = null
        state.six = null
      }
    },
    SAVE_QUESTION_DATA (state, payload) {
      if (state[payload.question]) {
        state.answerValues = state.answerValues - state[payload.question]
      }
      state.answerValues = state.answerValues + payload.data
      state[payload.question] = payload.data
    },
    SAVE_DATA (state, payload) {
      state.games[payload.game] = payload.data
    },
    UPDATE_LOADER (state, payload) {
      state.gameLoading = payload
    },
    UPDATE_START (state, payload) {
      console.log('payload: ' + payload)
      state.startTest = payload
    },
    UPDATE_PLAYINGGAME (state, payload) {
      state.playingGame = payload
    },
    CALC_PROGRESS (state, payload) {
      state.total = 0
      state.questionArray = []
      for (var key in state) {
        if (state.hasOwnProperty(key)) {
          if (key !== 'total' &&
              key !== 'games' && 
              key !== 'startTest' && 
              key !== 'playingGame' && 
              key !== 'gameLoading' && 
              key !== 'answerValues' && 
              key !== 'questionArray' && 
              state[key] != null) {
            state.total++
            state.questionArray.push(state[key])
          }
          if (key == 'games') {
            for (var gameKey in state.games) {
              if (state.games.hasOwnProperty(gameKey) && state.games[gameKey].complete) {
                state.total++
              } 
            }
          }
        } 
      }
      if (state.total == 9) {
        state.total = 10
      }
    }
  },
  actions: {
    updateLoader ({commit}, payload) {
      commit('UPDATE_LOADER', payload)
    },
    updateStart ({commit}, payload) {
      commit('UPDATE_START', payload)
    },
    updatePlayingGame ({commit}, payload) {
      commit('UPDATE_PLAYINGGAME', payload)
    },
    clearData ({commit}, payload) {
      commit('CLEAR_DATA', payload)
    },
    saveQuestionData ({commit}, payload) {
      commit('SAVE_QUESTION_DATA', payload)
      this.dispatch('calcNewTotal')
    },
    saveData ({commit}, payload) {
      commit('SAVE_DATA', payload)
      this.dispatch('calcNewTotal')
    },
    calcNewTotal ({commit}, payload) {
      commit('CALC_PROGRESS', payload)
    }
  },
  getters: {
    StoreQuestionData (state) {
      return state
    },
    StoreGameData (state) {
      return state.games
    }
  }
}
